import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { handleFormChange, submitCreateForm } from "@/utils/formChange";
import { FC, FormEvent } from "react";
import { formInterface } from "@/interface/dataInterface";
import { Button } from "@/components/ui/button";
import { useRefresh } from "react-admin";
import {
  BaseInput,
  BaseInputGroup,
  BaseTextArea,
} from "@/components/input/CustomInputs";
import SelectFinal from "@/components/input/Select";

const InventoryForm: FC<formInterface> = ({ mode, formProp, setFormProp }) => {
  return (
    <div className="grid min-[500px]:grid-cols-2 place-items-center gap-4">
      <BaseInput
        id="name"
        label="Name"
        value={formProp.name}
        setProp={setFormProp}
      />
      {mode === "create" && (
        <BaseInput
          id="sku"
          label="SKU"
          value={formProp.sku}
          setProp={setFormProp}
        />
      )}
      <BaseInput
        id="category"
        label="Category"
        value={formProp.category}
        setProp={setFormProp}
      />
      <BaseInput
        id="price"
        label="Price"
        type="number"
        value={formProp.price}
        setProp={setFormProp}
      />
      <BaseInputGroup
        id="quantity"
        label="Stock"
        type="number"
        value={formProp.quantity}
        setProp={setFormProp}
      >
        <Input
          id="unit"
          placeholder="unit"
          type="text"
          value={formProp.unit}
          onChange={(e: FormEvent<HTMLInputElement>) =>
            handleFormChange(e, setFormProp)
          }
        />
      </BaseInputGroup>
      <BaseInputGroup
        id="min_stock_level"
        label="Stock alert"
        type="number"
        value={formProp.min_stock_level}
        setProp={setFormProp}
        required={false}
        placeholder="Stock alert level"
      >
        <Input
          id="unit"
          placeholder="unit"
          type="text"
          value={formProp.unit}
          onChange={(e: FormEvent<HTMLInputElement>) =>
            handleFormChange(e, setFormProp)
          }
        />
      </BaseInputGroup>
      <div className="w-full">
        <Label htmlFor="supplier_id" className="text-right mb-2">
          Supplier
        </Label>
        <SelectFinal
          id="supplier_id"
          value={formProp.supplier_id}
          setValue={(e: FormEvent<HTMLSelectElement>) =>
            handleFormChange(e, setFormProp)
          }
          resource="vendors"
          dataProp="vendor_name"
          required={true}
        />
      </div>
      <div className={`w-full ${mode === 'edit' && 'col-span-2'}`}>
        <BaseInput
            id="warranty_months"
            type="number"
            label="Warranty(months)"
            value={formProp.warranty_months}
            setProp={setFormProp}
            required={false}
            placeholder="Warranty month"
        />
      </div>
      <div className="w-full min-[500px]:col-span-2">
        <BaseTextArea
          id="description"
          label="Description"
          value={formProp.description}
          setProp={setFormProp}
          required={false}
        />
      </div>
    </div>
  );
};

export default InventoryForm;
